import polygonClipping from 'polygon-clipping'
import type { GeoArea, GeoPt } from '../types'
import { capRingsPerPolygon } from './capRings'
import { areasToClipperPolygons, clipperResultToGeo } from './clipperPolygons'

/**
 * The `filled` wash: the union of every hunt area minus every forbidden area,
 * the app's `calculateFilledAreas`. Holes survive, so an excluded lake or a
 * no-hunting zone is not washed as huntable ground.
 *
 * A thrown clip yields no wash rather than a crashed map: the outline layers
 * still draw, which is the same trade `unionAreaOutlines` makes.
 */
export function filledWashPolygons(huntAreas: readonly GeoArea[], forbiddenAreas: readonly GeoArea[]): GeoPt[][][] {
  const hunt = areasToClipperPolygons(huntAreas)
  if (hunt.length === 0) return []
  const forbidden = areasToClipperPolygons(forbiddenAreas)
  try {
    const union = polygonClipping.union(hunt[0], ...hunt.slice(1))
    const result = forbidden.length ? polygonClipping.difference(union, ...forbidden) : union
    return clipperResultToGeo(capRingsPerPolygon(result))
  } catch {
    return []
  }
}
